<template>
<div class="media-print-wrapper">
    <div class="labels">
        <div v-for="stock in stocks" :key="stock.id" class="label">
            <div class="line-helper no-print"></div>
            <div class="top">
                <div class="item-name">{{ stock.nama }}</div>
                <div class="details">{{ $formatPrice(stock.berat) }}gr<template v-if="stock.kadar"> / {{ stock.kadar }}</template></div>
            </div>
            <div class="bottom">
              <div class="barcode-wrapper">
                <img :src="baseUrl+'barcodes/'+stock.id+'.jpg'" style="max-width: 100%;" alt="" srcset="" @error="onBarcodeImageError">
                <span style="display: block;font-size: 10px;text-align: center;line-height: normal;padding: 0px;margin: 0px;font-family: arial;padding-top: 3px;">{{ stock.stock_barcode }}</span>
                 <!-- <svg class="barcode"
                    :jsbarcode-value="stock.stock_barcode"
                    jsbarcode-textmargin="0"
                    jsbarcode-margin="6"
                    jsbarcode-height="45"
                    jsbarcode-width="2">
                </svg> -->
              </div>
            </div>
        </div>
    </div>
    <!-- 
    <div class="label">
        <div class="top">
        <div><img src="https://www.computalabel.com/Images/C128.png" style="max-width: 100%;" alt="" srcset=""></div>
        </div>
        <div class="bottom">
        <div class="item-name">Gelang super panjang nama produk koleksi 2025</div>
        <div class="details">5gr / 24k</div>
        </div>
    </div> -->
    <div class="print-tools no-print d-flex" style="gap: 5px; align-items: center;">
        <div>
            <b-button size="sm" @click.prevent="confirmPrint" type="button" variant="success" :disabled="isLoading || !authorized">Print</b-button>
        </div>
        <div>
            <b-pagination v-if="total > limit" size="sm" class="pagination-no-border mt-1" @input="onChangePage" v-model="page" :per-page="limit" :total-rows="total">
            </b-pagination>
        </div>
        <div><b-select size="sm" v-model="limit" @change="onChangeLimit" :options="[
            { value: 1, text: 1 },
            { value: 5, text: 5 },
            { value: 10, text: 10 },
            { value: 25, text: 25 },
            { value: 50, text: 50 },
            { value: 75, text: 75 },
            { value: 100, text: 100 },
            { value: 125, text: 125 },
            { value: 150, text: 150 },
            { value: 175, text: 175 },
            { value: 200, text: 200 },
            { value: 225, text: 225 },
            { value: 250, text: 250 },
            { value: 300, text: 300 },
            { value: 350, text: 350 },
            { value: 400, text: 400 },
        ]"></b-select></div>
    </div>
</div>
</template>

<script>
import Stock from '@/models/Stock.js'
// import JsBarcode from 'jsbarcode'


const stockModel = new Stock()
export default {
  data () {
    return {
      baseUrl: process.env.VUE_APP_API_BASE_URL,
      isLoading: false,
      page: 1,
      limit: 100,
      total: 0,
      stocks: [],
      authorized: false,
      apiUrl: {
        stock: stockModel.endpoint
      }
    }
  },
//   watch: {
//     'page': function () {
//     //   this.doFilter()
//     },
//     'limit': function () {
//     //   this.doFilter()
//     }
//   },
  mounted() {
    this.loadData()
  },
  methods: {
    confirmPrint () {
      this.$bvModal.msgBoxConfirm('Persetujuan cetak dapat digunakan maksimal 3 kali. Lanjutkan mencetak barcode?', {
        title: 'Konfirmasi Cetak Barcode', okTitle: 'Cetak', cancelTitle: 'Batal', centered: true
      }).then(value => { if (value) this.consumeApproval() })
    },
    consumeApproval () {
      this.isLoading = true
      this.$nextTick().then(() => this.waitForBarcodeImages()).then(() => {
        return this.$http.post(process.env.VUE_APP_API_URL + 'approval-requests/' + this.$route.query.approval_request_id + '/consume-print')
      }).then(() => {
        this.authorized = false
        window.print()
      }).catch(error => this.$store.dispatch('notification/error', error)).finally(() => { this.isLoading = false })
    },
    waitForBarcodeImages () {
      const images = Array.from(this.$el.querySelectorAll('.barcode-wrapper img'))
      if (!images.length || images.every(image => image.complete && image.naturalWidth > 0)) {
        return Promise.resolve()
      }
      return Promise.all(images.map(image => {
        if (image.complete) return Promise.resolve()
        return new Promise(resolve => {
          image.addEventListener('load', resolve, { once: true })
          image.addEventListener('error', resolve, { once: true })
        })
      }))
    },
    onBarcodeImageError () {
      this.$store.dispatch('notification/error', 'Gambar barcode tidak dapat dimuat.')
    },
    onChangeLimit () {
        this.page = 1;
        this.loadData()
    },
    onChangePage () {
        this.loadData()
    },
    loadData () {
      if (this.isLoading || !this.$route.query.approval_request_id) {
        return false;
      }
      this.isLoading = true
      const request = this.$route.query.stock_in_id
        ? this.$http.get(process.env.VUE_APP_API_URL + 'stock-ins/' + this.$route.query.stock_in_id + '/barcodes')
        : this.$http.get(stockModel.getEndpoint() + '/' + this.$route.query.stock_id)

      request.then(response => {
        this.stocks = this.$route.query.stock_in_id ? response.data : [response.data]
        this.total = this.stocks.length
        this.authorized = this.stocks.length > 0
      }).catch(error => this.$store.dispatch('notification/error', error)).finally(() => { this.isLoading = false })
    }
  }
}
</script>
<style lang="scss">
@media print {
    .no-print {
        display: none !important;
        opacity: 0 !important;
    }
    .media-print-wrapper .labels .label{
        margin: unset !important;
    }
    @page {
        /* size: 8.2cm 9.9cm; */
        size: 7.7cm 3cm;
        /* margin: 0.2cm; */
    }
    body {
      min-width: 0 !important;
    }
    .container {
      min-width: 0 !important;
    }
    .media-print-wrapper {
     .labels {
        .label, .top, .bottom{
            background-color: transparent !important;
            border-bottom-width: 0px !important;
        }
      }
    }
}

.media-print-wrapper {
    line-height: normal !important;
     .labels {
        .label{
            position: relative;
            margin: auto;
            background-color: #ececec;
            border-bottom: 1px solid #ccc;
            &:last-child {
                border-bottom-width: 0px;
            }

            /* border: 1px dashed #ccc;  */
            width: 7.7cm;
            height: 3cm;
            padding: 0cm;
            font-family: sans-serif;
            display: flex;
            flex-direction: column;
            justify-content: center;
        }

        .line-helper {
            height: 6px;
            background-color: #fff;
            position: absolute;
            width: calc(7.7cm - 3cm);;
            bottom: calc((1.25cm / 2) + 6px);
            left: 3cm;
        }

        .top {
            background-color: #fff;
            height: 1.25cm;
            width: 3cm;
            /* width: 2.9cm; */
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            transform: rotate(-180deg);
            border-bottom-left-radius: 6px;
            border-bottom-right-radius: 6px;
        }

        .top .item-name {
            text-align: center;
            font-size: 8px;
            max-width: 2.7cm; /* batas lebar */
            overflow: hidden;
            // text-overflow: ellipsis;
            // white-space: nowrap;
            white-space: normal;
            max-height: 26px;
            position: relative;
            // &:after {
            //   content: '...';
            //   position: absolute;
            //   bottom: 0px;
            //   right: 0px;
            // }
        }

        .top .details {
            text-align: center;
            font-size: 10px;
            /* font-weight: bold; */
        }

        .bottom {
            background-color: #fff;
            height: 1.25cm;
            width: 3cm;
            /* width: 2.9cm; */
            display: flex;
            justify-content: center;
            align-items: center;
            font-size: 12px;
            /* border-bottom: 1px dashed #ccc; */
            .barcode {
                max-height: 1cm;
            }
            .barcode-wrapper {
              padding: 0.2px 0.2cm 0 0.1cm;
            }
            svg {
              max-width: 100%;
            }
            border-bottom-left-radius: 6px;
            border-bottom-right-radius: 6px;
        }
     }
     .print-tools {
        position: fixed;
        bottom: 10px;
        right: 10px;
        .pagination {
            margin-bottom: 3px !important;
        }
     }
}
body {
    margin: 0 !important;
    padding: 0 !important;
}
</style>
